import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  wrapper: {
    '& h4': {
      fontSize: '0.875em',
      margin: '0',
    },
    '& p': {
      margin: '0',
      fontSize: '0.750em',
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <h4>
        <i>Permit Void when owner changes</i>
      </h4>
      <p>This permit is issued in compliance with Section 4-24-23-UCA.</p>
      <p>
        This permit must accompany Horse at all times when in transit
        in compliance with Utah laws governing inter-state movement.
      </p>
    </div>
  );
};

export default Footer;
